import { useEffect, useState } from 'react';
import { api } from '../api/client';
import Markdown from '../guides/Markdown';
import { useLanguage } from '../i18n/i18n';

export default function DpaAdminPage() {
  const { lang, t } = useLanguage();
  const [text, setText] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api<string>('/admin/dpa', { token: true })
      .then(setText)
      .catch((e) => setError(e instanceof Error ? e.message : t('That could not be loaded just now.')));
  }, [t]);

  return (
    <section style={{ maxWidth: 860, margin: '0 auto' }}>
      <div className="card">
        {lang !== 'en' && <p className="field-hint" style={{ marginTop: 0 }}>{t('This page is only available in English for now.')}</p>}
        {error && <div className="error" role="alert">{error}</div>}
        {text === null && !error && <p className="muted">{t('Loading…')}</p>}
        {text !== null && (
          <div lang="en" dir="ltr">
            <Markdown text={text} />
          </div>
        )}
      </div>
    </section>
  );
}
